import { Theme } from "@qendo/theme";
import { Slot } from "expo-router";
import * as SplashScreen from "expo-splash-screen";
import { useLayoutEffect, useState } from "react";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { KeyboardProvider } from "react-native-keyboard-controller";
import { EventProvider } from "react-native-outside-press";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { LoadingMask } from "~/components/feedback/LoadingMask";
import { PaperTheme } from "~/components/PaperTheme";
import ApiProvider from "~/providers/ApiProvider";
import { DismissProvider } from "~/providers/DismissProvider";
import { ErrorBagProvider } from "~/providers/ErrorBagProvider";
import { FeedbackProvider } from "~/providers/FeedbackProvider";
import { ModalProvider } from "~/providers/ModalProvider";
import { useNotificationObserver } from "~/providers/NotificationsProvider";
import { OnboardingProvider } from "~/providers/OnboardingProvider";
import { ResourcesProvider } from "~/providers/ResourcesProvider";
import { SessionProvider } from "~/providers/SessionProvider";
import { SystemOptionsProvider } from "~/providers/SystemOptionsProvider";
import { ThemeProvider } from "~/providers/ThemeProvider";
import { makePaperTheme } from "~/util/theme";

// Keep the splash screen visible while we fetch resources
SplashScreen.preventAutoHideAsync();

const paperTheme = makePaperTheme(Theme.light_blue);

export default function RootLayout() {
    const [loaded, setLoaded] = useState(false);
    const [hydrated, setHydrated] = useState(false);

    useNotificationObserver();

    useLayoutEffect(() => {
        if (!loaded) {
            setTimeout(() => {
                SplashScreen.hide();
                setLoaded(true);
            }, 250);
        } else if (!hydrated) {
            setTimeout(() => setHydrated(true), 250);
        }
    }, [hydrated, loaded]);

    return (
        <ThemeProvider>
            {hydrated ? (
                <GestureHandlerRootView>
                    <EventProvider>
                        <SafeAreaProvider>
                            <KeyboardProvider>
                                <PaperTheme theme={paperTheme}>
                                    <ErrorBagProvider>
                                        <ModalProvider>
                                            <FeedbackProvider>
                                                <ApiProvider>
                                                    <ResourcesProvider>
                                                        <SystemOptionsProvider>
                                                            <SessionProvider>
                                                                <OnboardingProvider>
                                                                    <DismissProvider>
                                                                        <Slot />
                                                                    </DismissProvider>
                                                                </OnboardingProvider>
                                                            </SessionProvider>
                                                        </SystemOptionsProvider>
                                                    </ResourcesProvider>
                                                </ApiProvider>
                                            </FeedbackProvider>
                                        </ModalProvider>
                                    </ErrorBagProvider>
                                </PaperTheme>
                            </KeyboardProvider>
                        </SafeAreaProvider>
                    </EventProvider>
                </GestureHandlerRootView>
            ) : (
                <LoadingMask />
            )}
        </ThemeProvider>
    );
}
